import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import rehypeRaw from "rehype-raw";
import "./html-view.scss";

const HtmlView = ({ html }) => {
  return (
    <div className="html-view">
      <ReactMarkdown children={html} rehypePlugins={[rehypeRaw]} />
    </div>
  );
};

export default HtmlView;